<script setup lang="ts">
import WrongLogin from '@/components/login/errorAlert/WrongLogin.vue';
import NewThirdPartSignupForm from '@/components/login/NewThirdPartSignupForm.vue';
import NewThirdPartSMSVerification from '@/components/login/NewThirdPartSMSVerification.vue';
import type { ThirdPartyLogin } from '@/models/interface/auth';

const showForm = shallowRef<{ [key: string]: Component }>({
  NewThirdPartSignupForm,
  NewThirdPartSMSVerification,
});
const showAlert = shallowRef<{ [key: string]: Component }>({
  WrongLogin
});
const dialogVisible = defineModel('dialogVisible', { default: false });
const showPopup = ref(false);
const formChoose = ref('NewThirdPartSignupForm');
const information = ref<ThirdPartyLogin>({
  name: '',
  phone: '',
  sex: -1,
  code: ''
});
</script>

<template>
  <div>
    <div class="custom-dialog">
      <el-dialog v-model="dialogVisible" :show-close="false" :close-on-press-escape="false" :align-center="true" :z-index="2011">
        <component
          v-model:formChoose="formChoose"
          v-model:showPopup="showPopup"
          v-model:showAlert="showAlert"
          v-model:information="information"
          v-model:dialogFormVisible="dialogVisible"
          :is="showForm[formChoose]"
        />
      </el-dialog>

      <PopupOverlay v-model:showPopup="showPopup" :zIndex="9999">
        <component v-model:showPopup="showPopup" v-model:formChoose="formChoose" :is="showAlert" />
      </PopupOverlay>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/** style */
.custom-dialog {
  :deep(.el-dialog) {
    padding: 0;
    border-radius: 8px;
  }
  :deep(.el-dialog__header) {
    padding-bottom: 0;
  }
}

.dialog-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  line-height: 140%;
  letter-spacing: 0px;
  color: #191919cc;

  h3 {
    font-weight: 600;
    font-size: 20px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    border-radius: 4px;
    outline: none;
    border: 0;
    background-color: #f74768;
    width: 100%;
    padding: 8px 0;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    span {
      font-weight: 400;
      font-size: 16px;
      line-height: 125%;
      letter-spacing: 0px;
    }
  }
}

.dialog-top {
  position: relative;
  height: 240px;
  background-color: #d9d1c6;
  border-radius: 8px 8px 0 0;
  z-index: 1;

  img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .close {
    position: absolute;
    right: 8px;
    top: 8px;
    color: #19191999;
    cursor: pointer;
    z-index: 1;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
